import React, { useState } from 'react'
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';

const Drawal = () => {

    const [isDrawerOen, setDrawerOen] = useState(false);
    return (
        <>


            <div className="burger" onClick={() => setDrawerOen(true)}>
                <span className="burger-line"></span>
                <span className="burger-line"></span>
                <span className="burger-line"></span>
            </div>





            <Drawer
                anchor="left"
                open={isDrawerOen}
                onClose={() => setDrawerOen(false)}>

                <Box
                    sx={{ width: 250 }}
                    role="presentation"

                >
                    <List>
                        <Link to="/crocent-story" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="The Crocent Story" />
                            </ListItemButton></ListItem>
                        </Link>

                        <Link to="/about" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="About" />
                            </ListItemButton></ListItem>
                        </Link>
                        <Link to="/industries" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="Our Business" />
                            </ListItemButton></ListItem>
                        </Link>
                        <Link to="/apply-crocent-international" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="Careers" />
                            </ListItemButton></ListItem>
                        </Link>
                        <Link to="/blogs" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="Blogs" />
                            </ListItemButton></ListItem>
                        </Link>
                        <Link to="/contact-us" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="Contact Us" />
                            </ListItemButton></ListItem>
                        </Link>
                        <Link to="/privacy-policy" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="Privacy Policy" />
                            </ListItemButton></ListItem>
                        </Link>
                        <Link to="/terms-and-conditions" className='drawer_link'>
                            <ListItem disablePadding><ListItemButton>
                                <ListItemText primary="Terms & Conditions" />
                            </ListItemButton></ListItem>
                        </Link>
                    </List></Box></Drawer></>
    )
}

export default Drawal